import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-database-exports',
  templateUrl: './database-exports.component.html',
  styleUrls: ['./database-exports.component.css']
})
export class DatabaseExportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
